import { Camera, Chatbox, Home, Person, DocumentText } from "react-ionicons";
import { FaGithub, FaInstagram, FaLinkedin } from "react-icons/fa";
import logo from "../assets/logo.svg";
import img2 from "../image/img2.jpeg";
import img3 from "../image/img3.jpeg";
import img4 from "../image/img4.jpeg";
import img5 from "../image/img5.jpeg";
import img6 from "../image/img6.jpeg";
import img7 from "../image/img7.jpeg";
import img8 from "../image/img8.jpeg";

// Import SVG files for technologies
import angular from "../assets/tech/angular.svg";
import argocd from "../assets/tech/argocd.svg";
import aws from "../assets/tech/aws.svg";
import bootstrap from "../assets/tech/bootstrap.svg";
import docker from "../assets/tech/docker.svg";
import gcp from "../assets/tech/gcp.svg";
import github from "../assets/tech/github.svg";
import gitlab from "../assets/tech/gitlab.svg";
import gradle from "../assets/tech/gradle.svg";
import grafana from "../assets/tech/grafana.svg";
import java from "../assets/tech/java.svg";
import jira from "../assets/tech/jira.svg";
import junit from "../assets/tech/junit.svg";
import kafka from "../assets/tech/kafka.svg";
import kibana from "../assets/tech/kibana.svg";
import liquibase from "../assets/tech/liquibase.svg";
import maven from "../assets/tech/maven.svg";
import mongodb from "../assets/tech/mongodb.svg";
import postgresql from "../assets/tech/postgresql.svg";
import prometheus from "../assets/tech/prometheus.svg";
import pubsub from "../assets/tech/pubsub.svg";
import python from "../assets/tech/python.svg";
import react from "../assets/tech/react.svg";
import redis from "../assets/tech/redis.svg";
import spock from "../assets/tech/spock.png";
import spring from "../assets/tech/spring.svg";
import springboot from "../assets/tech/springboot.svg";
import tailwind from "../assets/tech/tailwind.svg";

export const menuItems = [
  { icon: <Home color={"#ffffff"} />, text: "Home", path: "/" },
  { icon: <Person color={"#ffffff"} />, text: "My story", path: "/my-story" },
  { icon: <Camera color={"#ffffff"} />, text: "Who am I", path: "/who-am-i" },
  { icon: <Chatbox color={"#ffffff"} />, text: "Contact", path: "/contact" },
  { icon: <DocumentText color={"#ffffff"} />, text: "CV", path: "/cv" },
];

const slides = [
  {
    img: img2,
    title: "COMMUNICATIVE",
    type: "SOCIABLE",
    description:
      "Communicating clearly, setting boundaries have been in my toolbox for a very long time. I despise lies and do not like understatements. I believe that thanks to these things I made some really good friends along the way.",
  },
  {
    img: img3,
    title: "CALCULATED RISK-TAKER",
    type: "ADVENTUROUS",
    description:
      "The only thing that is constant in life is change. I like changes if they are well thought through and actually improve something, make something better. Every change comes with a risk, however I don't mind taking calculated risk.",
  },
  {
    img: img4,
    title: "POSITIVE",
    type: "OPTIMISTIC",
    description:
      "Life comes with many challanges. I always focus on positive things and try to see the brighter side in every situation, being aware of the other, darker one. The same apply to challanges at work. One may see them as obstacles, I see them as opportunities to learn and grow always taking the risk into account.",
  },
  {
    img: img5,
    title: "DISCIPLINED",
    type: "CONSISTENT",
    description:
      "Maintaining discipline in daily tasks and consistently grinding even in hard times makes me reliable in life as well as at work.",
  },
  { img: img6, title: "CALM", type: "PROFESSIONAL", description: "Lorem ipsum..." },
  {
    img: img7,
    title: "CURIOUS",
    type: "EXPLORER",
    description:
      "World is constantly evolving. If you stay in place, your moving backwards. That is why I like learning new things and improve myself on different aspects. I try to be better 1% than I was a day before.",
  },
  {
    img: img8,
    title: "SMART WORK",
    type: "HARD WORK",
    description:
      "First working smart, then working hard. There is no point in working hard and being ineffective. First, I identify and focus on the most important 20% and then I work hard to achieve 80% of the results.",
  },
];

// Technology icons and names
const techHeight = 50;
const technologies = [
  {
    icon: <img src={angular} height={techHeight} width={techHeight} alt="Angular" />,
    text: "Angular",
  },
  {
    icon: <img src={argocd} height={techHeight} width={techHeight} alt="Argo CD" />,
    text: "Argo CD",
  },
  { icon: <img src={aws} height={techHeight} width={techHeight} alt="AWS" />, text: "AWS" },
  {
    icon: <img src={bootstrap} height={techHeight} width={techHeight} alt="Bootstrap" />,
    text: "Bootstrap",
  },
  {
    icon: <img src={docker} height={techHeight} width={techHeight} alt="Docker" />,
    text: "Docker",
  },
  { icon: <img src={gcp} height={techHeight} width={techHeight} alt="GCP" />, text: "GCP" },
  {
    icon: <img src={github} height={techHeight} width={techHeight} alt="GitHub" />,
    text: "GitHub",
  },
  {
    icon: <img src={gitlab} height={techHeight} width={techHeight} alt="GitLab" />,
    text: "GitLab",
  },
  {
    icon: <img src={gradle} height={techHeight} width={techHeight} alt="Gradle" />,
    text: "Gradle",
  },
  {
    icon: <img src={grafana} height={techHeight} width={techHeight} alt="Grafana" />,
    text: "Grafana",
  },
  { icon: <img src={java} height={techHeight} width={techHeight} alt="Java" />, text: "Java" },
  { icon: <img src={jira} height={techHeight} width={techHeight} alt="Jira" />, text: "Jira" },
  { icon: <img src={junit} height={techHeight} width={techHeight} alt="JUnit" />, text: "JUnit" },
  {
    icon: (
      <img
        src={kafka}
        fill="white"
        height={techHeight * 0.8}
        width={techHeight * 0.8}
        alt="Kafka"
      />
    ),
    text: "Kafka",
  },
  {
    icon: <img src={kibana} height={techHeight} width={techHeight} alt="Kibana" />,
    text: "Kibana",
  },
  {
    icon: <img src={liquibase} height={techHeight} width={techHeight} alt="Liquibase" />,
    text: "Liquibase",
  },
  { icon: <img src={maven} height={techHeight} width={techHeight} alt="Maven" />, text: "Maven" },
  {
    icon: <img src={mongodb} height={techHeight} width={techHeight} alt="MongoDB" />,
    text: "MongoDB",
  },
  {
    icon: <img src={postgresql} height={techHeight} width={techHeight} alt="PostgreSQL" />,
    text: "PostgreSQL",
  },
  {
    icon: <img src={prometheus} height={techHeight} width={techHeight} alt="Prometheus" />,
    text: "Prometheus",
  },
  {
    icon: <img src={pubsub} height={techHeight} width={techHeight} alt="Pub/Sub" />,
    text: "Pub/Sub",
  },
  {
    icon: <img src={python} height={techHeight} width={techHeight} alt="Python" />,
    text: "Python",
  },
  { icon: <img src={react} height={techHeight} width={techHeight} alt="React" />, text: "React" },
  { icon: <img src={redis} height={techHeight} width={techHeight} alt="Redis" />, text: "Redis" },
  { icon: <img src={spock} height={techHeight} width={techHeight} alt="Spock" />, text: "Spock" },
  {
    icon: <img src={spring} height={techHeight} width={techHeight} alt="Spring" />,
    text: "Spring",
  },
  {
    icon: <img src={springboot} height={techHeight} width={techHeight} alt="Spring Boot" />,
    text: "Spring Boot",
  },
  {
    icon: <img src={tailwind} height={techHeight} width={techHeight} alt="Tailwind" />,
    text: "Tailwind",
  },
];

const experiences = [
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: logo,
    iconBg: "#383E56",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: logo,
    iconBg: "#383E56",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: logo,
    iconBg: "#383E56",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: logo,
    iconBg: "#383E56",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: logo,
    iconBg: "#383E56",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
];

const socials = [
  {
    name: "Linkedin",
    icon: <FaLinkedin color={"#0e76a8"} />,
    path: "https://www.linkedin.com/in/jacek-chmiel-5184751bb/",
    color: "#0e76a8",
  },
  {
    name: "Github",
    icon: <FaGithub color={"#ffffff"} />,
    path: "https://github.com/jacchm",
    color: "white",
  },
  {
    name: "Instagram",
    icon: <FaInstagram color={"#E1306C"} />,
    path: "https://www.instagram.com/jacek.chmiel.93/",
    color: "#E1306C",
  },
];

export { slides, technologies, experiences, socials };
